export default {
  iframe: '/iframe',
  teamsSuccess: '/teams-success',
  home: '/',
  login: '/login',
  register: '/register',
  emailVerify: '/verify',
  invite: '/invite',
  passwordReset: '/passwordReset',
  passwordChange: '/passwordChange',
  integration: {
    verify: {
      hubspot: '/verify/hubspot',
      salesforce: '/verify/salesforce',
      slack: '/verify/slack',
      msteams: '/verify/msteams',
      zendesk: '/verify/zendesk',
      microsoft: '/verify/microsoft',
      google: '/verify/google',
      pardot: '/verify/pardot',
      eloqua: '/verify/eloqua',
      zoho: '/verify/zoho',
      msDynamics: '/verify/msdynamics',
    },
    redirect: '/redirect/:appName',
  },
  project: {
    root: '/',
    details: '/',
    billing: '/billing',
    analytic: '/analytic',
    profile: '/settings/profile',
    inbox: {
      root: '/inbox',
      detail: '/inbox/:conversationId',
    },
    audiences: {
      root: '/conversations',
      detail: '/conversations/:conversationId',
    },
    mySettings: '/settings/profile',
    analytics: '/analytics',
    projectSettings: {
      configuration: '/settings/configurations',
      integrations: '/settings/integrations',
      team: '/settings/team',
      widget: '/settings/widget',
      pricing: '/settings/pricing',
      meeting: '/settings/meeting',
      profile: '/settings/profile',
      conversations: {
        root: '/conversations',
        details: '/conversations/:conversationId',
        build: '/conversations/:conversationId/build',
        test: '/conversations/:conversationId/build/test',
      },
      bot: {
        root: '/bot',
        integrations: '/bot/integrations',
        settings: '/bot/settings',
      },
    },
    meetings: '/meetings',
    cs: {
      internalAnalytics: '/cs/internal-analytics',
      customerRecords: '/cs/customer-records',
      createInstance: '/cs/create-instance',
    },
  },
  errorPage: {
    404: '/404',
    500: '/500',
  },
  notAuthorized: '/notAuthorized',
};
